<template>
    <svg
        fill="none"
        viewBox="0 0 24 24"
        height="14"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            clip-rule="evenodd"
            d="m3 4c0-.55228.44772-1 1-1h8c.5523 0 1-.44772 1-1s-.4477-1-1-1h-8c-1.65685 0-3 1.34315-3 3v11c0 1.6569 1.34315 3 3 3v2.5858c0 1.3333 1.08088 2.4142 2.41421 2.4142.64029 0 1.25436-.2544 1.70711-.7071l4.29288-4.2929h7.5858c1.6569 0 3-1.3431 3-3v-3c0-.5523-.4477-1-1-1s-1 .4477-1 1v3c0 .5523-.4477 1-1 1h-8c-.2652 0-.5196.1054-.7071.2929l-4.58579 4.5858c-.07768.0777-.18304.1213-.2929.1213-.22876 0-.41421-.1854-.41421-.4142v-3.5858c0-.5523-.44772-1-1-1h-1c-.55228 0-1-.4477-1-1zm14 1c0-1.10457.8954-2 2-2s2 .89543 2 2-.8954 2-2 2-2-.89543-2-2zm2-4c-2.2091 0-4 1.79086-4 4s1.7909 4 4 4 4-1.79086 4-4-1.7909-4-4-4z"
            fill="rgb(var(--v-theme-fontLight))"
            fill-rul="evenodd"
        />
    </svg>
</template>
